import React, { useCallback, useEffect, useRef } from 'react';
import styles from './header.module.css';
import SmartLink from '../common/smart-link';

const links = [
  // { href: '#about-book', text: 'Book' },
  { href: '#order-header', text: 'Order', isPreorder: true },
  { href: '#subscribe', text: 'Subscribe', isSubscribe: true },
  { href: '#media', text: 'Media' },
  // { href: '#events', text: 'Events' },
  // { href: '#about-author', text: 'About' },
  { href: '#contact', text: 'Contact' }
];

interface NavLinksProps {
  onLinkClick?: () => void;
}

export default function NavLinks({ onLinkClick }: NavLinksProps) {
  const navListRef = useRef<HTMLUListElement>(null);
  const backgroundRef = useRef<HTMLDivElement>(null);
  const lastHoveredRef = useRef<HTMLAnchorElement | null>(null);

  const updateBackgroundPosition = useCallback((target: HTMLAnchorElement | null) => {
    const background = backgroundRef.current;
    if (!background || !target) {
      if (background) {
        background.style.width = '0';
        background.style.opacity = '0';
      }
      return;
    }

    const rect = target.getBoundingClientRect();
    const navRect = navListRef.current?.getBoundingClientRect();
    if (!navRect) return;

    background.style.width = `${rect.width}px`;
    background.style.transform = `translateX(${rect.left - navRect.left}px)`;
    background.style.opacity = '1';
  }, []);

  const handleMouseEnter = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    const link = e.currentTarget;
    lastHoveredRef.current = link;
    updateBackgroundPosition(link);
  }, [updateBackgroundPosition]);

  const handleMouseLeave = useCallback(() => {
    lastHoveredRef.current = null;
    updateBackgroundPosition(null);
  }, [updateBackgroundPosition]);

  useEffect(() => {
    const onScroll = () => updateBackgroundPosition(lastHoveredRef.current);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [updateBackgroundPosition]);

  return (
    <ul className={styles.navList} ref={navListRef}>
      <div className={styles.navSlidingBackground} ref={backgroundRef} />
      {links.map(({ href, text }) => (
        <li key={href}>
          <SmartLink
            href={href}
            className={styles.navLink}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onLinkClick={onLinkClick}
          >
            {text}
          </SmartLink>
        </li>
      ))}
    </ul>
  );
}